<template>
  <div>
    <v-layout justify-center mb-3>
      <span class="grey--text text-center textoAjustado" xs2 style="font-size:19px"><slot></slot></span>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'o-description-title'
}
</script>